import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function AdminLogin() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  if (user?.isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  async function go(e: React.FormEvent) {
    e.preventDefault();
    try {
      await api("/api/admin/login", { method: "POST", body: JSON.stringify({ password }) });
      nav("/admin");
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : "Erreur");
    }
  }

  return (
    <form onSubmit={(e) => void go(e)} className="max-w-sm grid gap-3 pt-10">
      <h1 className="font-display text-3xl">Administration</h1>
      <p className="text-sm opacity-80">Le compte Ladrio entre sans mot de passe. Sinon, saisis le mot de passe atelier.</p>
      <input
        type="password"
        className="rounded-2xl bg-cream text-ink px-4 py-3"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {err && <p className="text-pink">{err}</p>}
      <button className="rounded-2xl bg-gold text-ink py-3 font-bold" type="submit">
        Entrer
      </button>
    </form>
  );
}
